import {Component, Input} from '@angular/core';
import {NavController} from "ionic-angular";
import {InviteBarbershopPage} from "../../pages/invite-barbershop/invite-barbershop";

@Component({
  selector: 'invite-barbershop',
  templateUrl: 'invite-barbershop.html'
})
export class InviteBarbershopComponent {

  @Input() shops: any;
  @Input() fromSearch: boolean = false;

  constructor(
    public navCtrl: NavController,
  ) {

  }

  openPage() {
    this.navCtrl.push(InviteBarbershopPage)
  }


}



// WEBPACK FOOTER //
// ./src/components/invite-barbershop/invite-barbershop.ts